import { AppNS } from 'app';

import { RolesWithPermissions } from '../';

export const isStateEditable = (ticket: AppNS.Ticket) =>
  ticket.state === 'dob_action_required' || ticket.state === 'subject_action_required';

export const TICKETS_ROLES: RolesWithPermissions = {
  admin: {
    tickets: {
      view: true,
      create: false,
    },
  },
  general: {
    tickets: {
      view: true,
      create: false,
      assign: false,
    },
  },
  supervisor: {
    tickets: {
      view: true,
      create: true,
      assign: (currentUser, ticket) => isStateEditable(ticket),
      update: (currentUser, ticket) => isStateEditable(ticket) && currentUser.id === ticket.reviewerId,
    },
  },
  backoffice: {
    tickets: {
      view: true,
      create: true,
      assign: (currentUser, ticket) => isStateEditable(ticket),
      update: (currentUser, ticket) => isStateEditable(ticket) && currentUser.id === ticket.reviewerId,
    },
  },
  client: {
    tickets: {
      view: true,
      create: false,
    },
  },
  agency: {
    tickets: {
      view: true,
      create: false,
    },
  },
  '3rd_inspector': {
    tickets: {
      view: false,
      create: false,
    },
  },
  inspector: {
    tickets: {
      view: false,
      create: false,
    },
  },
};
